const GetBirthDateFromPersonalId = (personalId: string): string | null => {
   const prefix = personalId.replace(/[\s/]/g, "").slice(0, 6);
   if (!/^\d{6}$/.test(prefix)) {
      return null;
   }

   const today = new Date();
   let year = Math.floor(today.getFullYear() / 100) * 100 + Number(prefix.slice(0, 2));
   let month = Number(prefix.slice(2, 4));
   const day = Number(prefix.slice(4, 6));
   if (month > 70) {
      month -= 70;
   } else if (month > 50) {
      month -= 50;
   } else if (month > 20) {
      month -= 20;
   }

   if (new Date(year, month - 1, day) > today) {
      year -= 100;
   }
   const date = new Date(year, month - 1, day);
   if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return null;
   }

   return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

export default GetBirthDateFromPersonalId;
